var _dec, _dec2, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { DashboardWebWithholdingConfigService } from '@square/dashboard-protos/models/squareup/bbfrontend/dashboardweb/withholding_config/withholding_config_service';
import { computed, notifyPropertyChange } from '@ember/object';
import rpc from '@banking/api/utils/rpc';
import { AccountScopedIdentifier } from '@square/dashboard-protos/models/squareup/bbfrontend/common/identifier/account_scoped_identifier';
let BBFrontendV1WithholdingConfigService = (_dec = computed('capitalEngineContext.headers'), _dec2 = computed('accountWithholdingConfigsMap'), _class = class BBFrontendV1WithholdingConfigService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor, this);
    _initializerDefineProperty(this, "locationSelector", _descriptor2, this);
    _defineProperty(this, "accountWithholdingConfigsMap", new Map());
  }
  get client() {
    return DashboardWebWithholdingConfigService.create(rpc((_, derivedUrl) => derivedUrl, new Map(Object.entries(this.capitalEngineContext.headers))));
  }
  get accountWithholdingConfigs() {
    return [...this.accountWithholdingConfigsMap.values()];
  }
  async fetchWithholdingConfigs(accountIds) {
    if (accountIds.length === 0) {
      return;
    }
    // Refresh units. We match units with their respective unit-level withholding configurations.
    await this.locationSelector.configure({
      hideInactiveUnits: true
    });
    const {
      accountWithholdingConfigs
    } = await this.client.listWithholdingConfigs({
      accountIds: {
        accountIds
      },
      owner: AccountScopedIdentifier.create({
        type: AccountScopedIdentifier.TokenType.TOKEN_TYPE_MERCHANT,
        token: this.capitalEngineContext.sessionContext.merchantToken
      })
    });
    accountWithholdingConfigs?.forEach(accountWithholdingConfig => {
      this.accountWithholdingConfigsMap.set(accountWithholdingConfig.accountId, accountWithholdingConfig);
    });
    notifyPropertyChange(this, 'accountWithholdingConfigs');
  }
  async list(accountIds = []) {
    // Only fetch for accounts that aren't cached
    const accountsToFetch = accountIds.filter(accountId => {
      return !this.accountWithholdingConfigsMap.has(accountId);
    });
    await this.fetchWithholdingConfigs(accountsToFetch);
    const accountWithholdingConfigs = [];
    accountIds.forEach(accountId => {
      const withholdingConfig = this.accountWithholdingConfigsMap.get(accountId);
      if (withholdingConfig) {
        accountWithholdingConfigs.push(withholdingConfig);
      }
    });
    return accountWithholdingConfigs;
  }
  async create(accountWithholdingConfigToCreate) {
    const {
      accountWithholdingConfig
    } = await this.client.createWithholdingConfig(accountWithholdingConfigToCreate);
    if (!accountWithholdingConfig) {
      throw new Error('failed to create account withholding config');
    }
    this.accountWithholdingConfigsMap.set(accountWithholdingConfig.accountId, accountWithholdingConfig);
    notifyPropertyChange(this, 'accountWithholdingConfigs');
    return accountWithholdingConfig;
  }
  async update(accountWithholdingConfigToUpdate) {
    const {
      accountWithholdingConfig
    } = await this.client.updateWithholdingConfig(accountWithholdingConfigToUpdate);
    if (!accountWithholdingConfig) {
      throw new Error('failed to update account withholding config');
    }
    this.addToAccountWithholdingConfigsMap(accountWithholdingConfig);
    return accountWithholdingConfig;
  }
  addToAccountWithholdingConfigsMap(accountWithholdingConfig) {
    this.accountWithholdingConfigsMap.set(accountWithholdingConfig.accountId, accountWithholdingConfig);
    notifyPropertyChange(this, 'accountWithholdingConfigsMap');
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "locationSelector", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "client", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "client"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "accountWithholdingConfigs", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "accountWithholdingConfigs"), _class.prototype), _class);
export { BBFrontendV1WithholdingConfigService as default };